export default __webpack_public_path__ + "static/media/sbo-img.5c6db782.webp";